<template>
  <main class="password-bind-container" :class="[displayLayout, isNewClass]">
    <p class="popup-title">{{ popupTitle }}</p>
    <section class="password-bind-content" :class="displayLayout">
      <!-- 设置您的账户密码: -->
      <div class="password-item">
        <div class="title">{{ $t('account.set_pw') }}</div>
        <password-base
          v-model="password"
          showKeyboardKey="passwordShowKeyboard"
          :showKeyboard="passwordShowKeyboard"
          @setShowKeyboard="setShowKeyboard"
        />
        <!-- 未输入密码提示 -->
        <div class="warning-item" v-if="errType === 1">
          <van-icon class="icon" name="warning" color="#F96000" />
          <div class="warning-message">{{ errorTipText }}</div>
        </div>
      </div>
      <!-- 再次输入您的账户密码: -->
      <div class="password-item">
        <div class="title">{{ $t('account.input_pw_again') }}</div>
        <password-base
          v-model="rePassword"
          showKeyboardKey="rePasswordShowKeyboard"
          :showKeyboard="rePasswordShowKeyboard"
          @setShowKeyboard="setShowKeyboard"
        />
        <!-- 新设置密码两次输入不一致提示 -->
        <div class="warning-item" v-if="errType === 2 || errType === 5">
          <van-icon class="icon" name="warning" color="#F96000" />
          <div class="warning-message">{{ errorTipText }}</div>
        </div>
      </div>
      <security-tip
        v-if="pwOperation === 'initPW'"
        :tip="$t('account.password_security_tip')"
      />
      <button
        class="submit-btn"
        :class="!isValid ? 'disabled' : ''"
        @click="confirm"
      >
        {{ $t('account.confirm') }}
      </button>
    </section>
  </main>
</template>

<script>
  import Vue from 'vue'
  import { mapState, mapGetters, mapMutations } from 'vuex'
  import { Toast } from 'vant'
  import PasswordBase from '@/components/PasswordBase'
  import SecurityTip from '../SecurityTip/index.vue'
  import { sixDigitsReg } from '@/utils/regExp'

  Vue.use(Toast)

  // 修改密码
  export default {
    name: 'password-setting',
    components: {
      PasswordBase,
      SecurityTip,
    },
    props: {
      show: Boolean,
      hasEmail: {
        type: Boolean,
        default: false,
      },
      configData: {
        type: Object,
        default: () => {},
      },
      pwOperation: {
        type: String,
        default: 'initPW',
      },
    },
    data() {
      return {
        password: '',
        rePassword: '',
        passwordShowKeyboard: true,
        rePasswordShowKeyboard: false,
        errType: 0,
      }
    },
    computed: {
      ...mapState(['paymentPassword', 'userInfo']),
      ...mapGetters(['displayLayout', 'isNewClass']),
      popupTitle() {
        const textMap = {
          initPW: this.$t('account.pw_setting'), //'绑定密码',
          resetPW: this.$t('account.pw_reset'),
        }
        return textMap[this.pwOperation]
      },
      errorTipText() {
        switch (this.errType) {
          case 1:
            return this.$t('account.input_pw') // 请输入密码
          case 2:
            return this.$t('account.diff_tip') // 两次密码输入不一致
          case 5:
            return this.$t('account.same_six_num') // 密码不能为六位相同数字
          default:
            return ''
        }
      },
      pwArr() {
        return [this.password, this.rePassword]
      },
      isValid() {
        return this.isPWfilled(this.pwArr) && this.errType === 0
      },
    },
    watch: {
      show(val) {
        if (!val) {
          // 关闭弹窗时清空密码
          this.password = ''
          this.rePassword = ''
        }
      },
      pwArr(arr) {
        this.type = 0
        if ((!this.password || this.password.length < 6) && this.rePassword) {
          // 未输入新密码，或者输入新密码长度不足6位的情况下输入确认密码
          this.errType = 1
        } else if (this.isPWfilled(arr) && this.password !== this.rePassword) {
          // 已输入新密码，但二次确认密码不一致
          this.errType = 2
        } else {
          this.errType = 0
        }
      },
      password(val) {
        if (sixDigitsReg.test(val)) {
          // 输入6位密码后自动换行
          if (!this.rePasswordShowKeyboard) {
            this.rePasswordShowKeyboard = true
            this.passwordShowKeyboard = false
          }
        }
      },
      rePassword(val) {
        const { password } = this
        if (
          sixDigitsReg.test(password) &&
          sixDigitsReg.test(val) &&
          password === val
        ) {
          // 判断两次输入的密码是否相同
          this.rePasswordShowKeyboard = false
        }
      },
    },
    methods: {
      ...mapMutations(['setPaymentPassword']),
      isPWfilled(strArr) {
        return (
          strArr &&
          strArr.length > 0 &&
          strArr.every((num) => {
            return sixDigitsReg.test(num)
          })
        )
      },
      setShowKeyboard({ showKeyboardKey, value }) {
        if (showKeyboardKey === 'passwordShowKeyboard') {
          // 展示指定数字键盘时,关闭其他键盘
          this.passwordShowKeyboard = value
          this.rePasswordShowKeyboard = false
        }
        if (showKeyboardKey === 'rePasswordShowKeyboard') {
          this.passwordShowKeyboard = false
          this.rePasswordShowKeyboard = value
        }
      },
      confirm() {
        if (!this.isValid) {
          return
        }
        if (/^(\d)\1{5}$/.test(this.password)) {
          return (this.errType = 5)
        }
        this.setPaymentPassword(this.password)
        // 继续邮箱认证流程
        if (this.pwOperation === 'initPW' && this.hasEmail) {
          // 只有存在登录邮箱的情况下初始化密码才无需验证邮箱
          this.$emit('jumpto', {
            type: 'request',
          })
        } else {
          this.$emit('jumpto', {
            type: 'email',
          })
        }
      },
    },
  }
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
<style lang="scss">
  // 不加 scoped 是为了能让下面的语句生效
  .password-bind-content {
    li.van-password-input__item {
      border: 1px solid #f9f9f9;
      border-radius: 12px;
      width: 120px;
      min-height: 120px;
      margin: 0 20px;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
    }
    &.desktop-layout {
      li.van-password-input__item {
        border: 1px solid #f9f9f9;
        border-radius: 4.6px;
        width: 47px;
        min-height: 46px;
        margin: 0 8.4px;
        &:first-child {
          margin-left: 0;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
</style>
